/*
  "The way to you" (sections/ik-journey.liquid) follows the chosen variant: status (in stock / on order),
  lead time and the chosen options. Hidden for variants that cannot be bought. The theme's picker writes
  ?variant= into the address and uses buttons, so the variant is read the same way as in
  assets/ik-product-story.js. Nothing is loaded, everything is in the page.
*/
(() => {
  const root = document.querySelector('[data-ikweg]');
  if (!root) return;
  let variants = [];
  try {
    variants = JSON.parse(root.querySelector('[data-ikweg-variants]').textContent) || [];
  } catch (e) {
    return;
  }
  if (!variants.length) return;

  const currentId = () => {
    const q = new URLSearchParams(location.search).get('variant');
    const f = document.querySelector('form.shopify-product-form [name="id"], form[action*="/cart/add"] [name="id"]');
    return String(q || (f && f.value) || variants[0].id);
  };

  let shown = '';
  const apply = () => {
    const id = currentId();
    if (id === shown) return;
    const v = variants.find((x) => String(x.id) === id);
    if (!v) return;
    shown = id;
    const live = v.state === 'ready' || v.state === 'order';
    root.hidden = !live;
    root.dataset.state = v.state;
    root.querySelectorAll('[data-ikweg-lead]').forEach((el) => { el.textContent = v.lead || ''; });
    root.querySelectorAll('[data-ikweg-needs-lead]').forEach((el) => { el.hidden = !v.lead; });
    root.querySelectorAll('[data-ikweg-option]').forEach((el) => {
      const value = (v.options || [])[Number(el.dataset.ikwegOption)];
      if (value != null) el.textContent = value;
    });
  };

  const later = () => setTimeout(apply, 400);
  document.addEventListener('change', later);
  document.addEventListener('click', (e) => e.target.closest('[role="option"], [data-position], .ikn-swatch, a[href*="variant="]') && later());
  window.addEventListener('popstate', later);
  apply();
})();
